import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { TwoTonedIcon } from '../iconTypes';

const IconAutoCAD = ({ className = '', height = 30, title, width = 30 }: TwoTonedIcon) => (
    <AccessibleSVG
        className={`icon-autocad ${className}`}
        height={height}
        title={title}
        viewBox="0 0 30 30"
        width={width}
    >
        <defs>
            <radialGradient
                id="b"
                cx="527.83"
                cy="-1214.99"
                r="25.46"
                gradientTransform="matrix(-.36 .92 .68 .26 1034.4 -168.33)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#69252a" />
                <stop offset=".15" stopColor="#803639" />
                <stop offset=".46" stopColor="#bb605e" />
                <stop offset=".74" stopColor="#f48a82" />
            </radialGradient>
            <radialGradient
                id="c"
                cx="156.62"
                cy="-1575.38"
                r="25.12"
                gradientTransform="matrix(-.37 .92 .67 .26 1117.49 283.6)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#793835" />
                <stop offset=".14" stopColor="#904743" />
                <stop offset=".43" stopColor="#cb6e68" />
                <stop offset=".61" stopColor="#f48a82" />
            </radialGradient>
            <radialGradient
                id="d"
                cx="-29.13"
                cy="-947.08"
                r="25.66"
                gradientTransform="matrix(.26 .95 .72 -.19 711.16 -140.86)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#793835" />
                <stop offset=".13" stopColor="#803c39" />
                <stop offset=".31" stopColor="#934945" />
                <stop offset=".52" stopColor="#b15e58" />
                <stop offset=".75" stopColor="#dc7a73" />
                <stop offset=".87" stopColor="#f48a82" />
            </radialGradient>
            <linearGradient
                id="a"
                x1="4"
                y1="778.43"
                x2="10.06"
                y2="765.34"
                gradientTransform="matrix(1 0 0 -1 0 795.88)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#512427" />
                <stop offset=".96" stopColor="#be2c34" />
            </linearGradient>
            <linearGradient id="e" x1="25.41" y1="757.72" x2="19.95" y2="774.02" xlinkHref="#a" />
            <linearGradient
                id="f"
                x1="18.72"
                y1="800.38"
                x2="-.27"
                y2="773.64"
                gradientTransform="matrix(1 0 0 -1 0 795.88)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#d22" />
                <stop offset=".04" stopColor="#d32424" />
                <stop offset=".21" stopColor="#ae292d" />
                <stop offset=".35" stopColor="#982d32" />
                <stop offset=".44" stopColor="#902e34" />
                <stop offset=".98" stopColor="#682427" />
            </linearGradient>
            <radialGradient
                id="g"
                cx="186.38"
                cy="-1038.13"
                r="37.77"
                gradientTransform="matrix(.24 .97 .64 -.16 641.18 -344.62)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#d22" />
                <stop offset=".74" stopColor="#942325" />
                <stop offset=".87" stopColor="#822326" />
                <stop offset="1" stopColor="#752326" />
            </radialGradient>
            <linearGradient
                id="h"
                x1="-.17"
                y1="773.63"
                x2="27.91"
                y2="778"
                gradientTransform="matrix(1 0 0 -1 0 795.88)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#512427" />
                <stop offset=".25" stopColor="#752326" />
                <stop offset=".48" stopColor="#942325" />
                <stop offset=".61" stopColor="#982325" />
                <stop offset=".73" stopColor="#a22324" />
                <stop offset=".84" stopColor="#b52324" />
                <stop offset=".95" stopColor="#ce2223" />
                <stop offset="1" stopColor="#d22" />
            </linearGradient>
        </defs>
        <path
            d="M3.09 29.62l-1.57-.69c.16-.86.59-2.62 1.23-5 0-.11.06-.23.1-.35.15-.58.32-1.19.5-1.82.13-.44.25-.89.38-1.34.85-3 2-6.19 2.77-8.54.12-.35.24-.68.34-1A83.08 83.08 0 0 1 11.66.14h6.42a59 59 0 0 1 3.68 7.61c.06.16.14.33.21.5.34.8.72 1.69 1.05 2.68.22.66.49 1.34.77 2.06.4 1 .81 2.11 1.13 3.18.41 1.42.84 2.95 1.31 4.68.4 1.44.75 2.74 1 3.78.35 1.31.59 2.18.66 2.37.14.37.45 1.61.55 2l-1.54.49-3.52.28-1.78-1.21a14.2 14.2 0 0 0-.29-2.51 45.86 45.86 0 0 0-1.21-4.75v-.11H20c-3.33.37-6.79.85-10.29 1.44h-.14v.09c-.07.38-.14.72-.19 1s-.15.78-.18.9c-.14.5-.2 3.28-.2 3.78l-2.39 1.46zM15 8c-.15 0-.43.08-.63.64-.83 2.37-1.51 4.11-2.06 5.51-.29.75-.54 1.4-.74 1.94l-.13.35.32-.18.6-.33c1.58-.86 3.11-1.65 4.55-2.34l.35-.17.11-.05v-.12c-.84-2.32-1.55-4.25-1.74-4.7S15.11 8 15 8z"
            fill="#d22"
        />
        <path
            d="M14.49 8.64c.24-.68.68-.74 1-.08.19.46.92 2.43 1.74 4.7.85-.44 1.24-.69 2-1.11-.84-1.89-3.45-7.36-3.77-7.83s-.34-.82-.75-.08-6.42 13-7.34 14.67c1.35-.81 2.46-1.63 4.3-2.64.51-1.54 1.52-3.94 2.82-7.63z"
            fill="url(#b)"
        />
        <path
            d="M9.29 22.84c-1.38.23-2.42.49-3.91.78v.08c-.37 1-1.86 4.75-2.23 6.06l3.43.24c.42-1 1.48-4 2.71-7.16z"
            fill="url(#c)"
        />
        <path
            d="M23.34 21.23c0-.06-.06-.14-.11-.25-1 .09-1.81.2-3.18.35 1.33 3.3 2.67 6.72 3.32 8.58l3.63-.28c-.17-.48-.54-1.63-1-2.63-.5-1.28-2.28-4.9-2.66-5.77z"
            fill="url(#d)"
        />
        <path
            d="M6.58 30h.07l2.46-1.52s.08-3.29.21-3.79c0-.2.19-1 .37-1.92l-.4.07C8.06 26 7 29 6.58 30z"
            fill="url(#a)"
        />
        <path
            d="M21.21 26.09a14.34 14.34 0 0 1 .29 2.55l1.87 1.27c-.65-1.86-2-5.28-3.32-8.58H20a47.18 47.18 0 0 1 1.21 4.76z"
            fill="url(#e)"
        />
        <path
            d="M11.59 0a82.8 82.8 0 0 0-4.87 10.86c-.85 2.48-2.14 6.14-3.11 9.55-.13.45-.26.9-.38 1.34-.18.62-.35 1.23-.51 1.81.07-.11.31-.78.73-1.9.16-.44.35-.94.57-1.51A153 153 0 0 1 13.39 0z"
            fill="url(#f)"
        />
        <path
            d="M26.37 20.81c-.4-1.46-.85-3.07-1.32-4.68-.53-1.82-1.35-3.63-1.89-5.25-.41-1.2-.9-2.29-1.27-3.18A54.38 54.38 0 0 0 18.16 0h-1.63c.82 1.56 3.08 5.94 5.54 11.38.7 1.55 1.42 3.18 2.12 4.86.63 1.5 1.25 3.05 1.84 4.6.48 1.25.94 2.5 1.36 3.75-.27-1.03-.62-2.34-1.02-3.78z"
            fill="#e02b2b"
        />
        <path
            d="M28 27c-.07-.18-.3-1.06-.65-2.36s-.88-2.5-1.36-3.75c-.59-1.55-1.21-3.1-1.84-4.6-.7-1.68-1.42-3.31-2.12-4.86-2.42-5.49-4.68-9.87-5.5-11.43h-3.14A153 153 0 0 0 4 20.15c-.22.57-.41 1.07-.57 1.51-.42 1.12-.66 1.79-.73 1.9l-.09.36C2 26.24 1.52 28.14 1.37 29l1.69.74c.42-1.29 1.94-5.05 2.28-6.04v-.08C5.62 23 6 22 6.4 21s.89-2 .92-2.11C8.23 17.26 14.26 5 14.66 4.24c.18-.35.43-.45.75.08s2.92 5.92 3.77 7.83c-.84.43-10 5.26-11.86 6.76 0 0-.64 1.35-.92 2.11a88.63 88.63 0 0 1 14.72-4.46c.85 1.81 1.76 3.66 2.11 4.42.05.11.09.19.11.25.38.87 2.16 4.49 2.7 5.77.42 1 .79 2.15.94 2.62l1.65-.53S28.21 27.41 28 27z"
            fill="url(#g)"
        />
        <path
            d="M21.12 16.56A74.83 74.83 0 0 0 6.4 21c-.35.94-.77 1.93-1 2.6 1.49-.29 2.53-.55 3.91-.78l.4-.07c4-.67 7.47-1.12 10.28-1.43h.08c1.37-.15 2.14-.27 3.18-.35-.37-.75-1.25-2.6-2.13-4.41z"
            fill="url(#h)"
        />
        <path
            d="M7.47 18.82c.45-.33.92-.64 1.39-.94s1-.59 1.45-.87c1-.57 1.94-1.13 2.92-1.68s2-1.09 3-1.62l3-1.61v.08c-.27-.59-.54-1.18-.82-1.76s-.57-1.17-.85-1.76l-1.71-3.5-.22-.43-.11-.22-.05-.11v-.05a.73.73 0 0 0-.14-.16.24.24 0 0 0-.33-.12.26.26 0 0 0-.16.09.52.52 0 0 0-.13.17v.06l-.05.11-.11.21-.22.44-.44.87-1.84 3.52c-.59 1.16-1.17 2.32-1.75 3.48s-1.15 2.33-1.72 3.5S7.47 18.86 6.92 20c-.27.59-.53 1.19-.79 1.78s-.52 1.19-.75 1.8c.22-.61.46-1.21.71-1.81s.51-1.2.77-1.79c.53-1.19 1.07-2.37 1.63-3.55s1.12-2.3 1.69-3.43 1.15-2.33 1.73-3.49L13.67 6l.45-.86.22-.44.11-.22.05-.1v-.12a.65.65 0 0 1 .22-.26.42.42 0 0 1 .28-.08.29.29 0 0 1 .16 0l.12.07a.91.91 0 0 1 .18.21v.06l.05.11.11.22.21.44c.58 1.16 1.14 2.33 1.71 3.5l.84 1.76c.28.59.56 1.17.82 1.77h-.06c-1 .54-2 1.06-3 1.59l-3 1.6L10.33 17c-.49.28-1 .57-1.45.86s-.96.63-1.41.96z"
            fill="#d97871"
        />
        <path
            d="M6.47 21l1.78-.71.9-.34.45-.17.45-.16.9-.33.91-.31.45-.16.46-.15.45-.15.46-.15.91-.28.92-.28c.62-.17 1.23-.35 1.85-.51 1.24-.33 2.49-.62 3.75-.84h.05c.4.87.82 1.74 1.23 2.61l.63 1.3.3.66.14.33.15.32c.4.88.82 1.74 1.23 2.62l.6 1.31c.2.43.4.87.58 1.32-.39-.88-.82-1.74-1.24-2.61l-.63-1.3c-.2-.43-.41-.86-.62-1.3l-.15-.33-.15-.32-.31-.66-.63-1.29c-.42-.87-.84-1.73-1.25-2.61h.07c-.63.11-1.25.24-1.87.39l-.47.1-.47.11-.46.12-.47.12c-.61.16-1.23.33-1.84.51l-.92.27-.92.28-.46.14-.45.15-.46.14-.46.15-.9.31-.91.31-1.81.65-.24.19-.23.08-.45.17z"
            fill="#d97871"
        />
    </AccessibleSVG>
);

export default IconAutoCAD;
